/**
 * upsell-carousel.js — desktop prev/next arrows for the cart upsell row.
 *
 * The upsell lays out as a native CSS scroll-snap row (great on touch). On
 * desktop this wires arrow buttons that scroll it, disables them at the ends,
 * and hides the whole set when there's nothing to scroll. Also swallows clicks
 * that were really scroll gestures: finger travel past a tap slop, or a click
 * landing while the row is still scrolling/settling. Decoupled from
 * theme.js; re-wires on cart events + when the drawer template clones in.
 */
(function () {
  'use strict';

  function update(row, prev, next, wrap) {
    const max = row.scrollWidth - row.clientWidth;
    prev.classList.toggle('is-disabled', row.scrollLeft <= 1);
    next.classList.toggle('is-disabled', row.scrollLeft >= max - 1);
    wrap.classList.toggle('upsell-carousel--static', max <= 1);
  }

  function wire(wrap) {
    if (wrap.dataset.upsellWired) return;
    const row = wrap.querySelector('[data-pair-products]');
    const prev = wrap.querySelector('[data-upsell-nav="prev"]');
    const next = wrap.querySelector('[data-upsell-nav="next"]');
    if (!row || !prev || !next) return;
    wrap.dataset.upsellWired = '1';

    const step = () => Math.max(row.clientWidth * 0.8, 170);
    prev.addEventListener('click', () => row.scrollBy({ left: -step(), behavior: 'smooth' }));
    next.addEventListener('click', () => row.scrollBy({ left: step(), behavior: 'smooth' }));

    const TAP_SLOP = 10;
    const SETTLE_MS = 80;
    let startX = 0;
    let startY = 0;
    let moved = 0;
    let lastScrollAt = 0;

    row.addEventListener(
      'touchstart',
      (e) => {
        startX = e.touches[0].clientX;
        startY = e.touches[0].clientY;
        moved = 0;
      },
      { passive: true }
    );

    row.addEventListener(
      'touchmove',
      (e) => {
        moved = Math.max(moved, Math.abs(e.touches[0].clientX - startX), Math.abs(e.touches[0].clientY - startY));
      },
      { passive: true }
    );

    row.addEventListener(
      'click',
      (e) => {
        const wasScroll = moved > TAP_SLOP || performance.now() - lastScrollAt < SETTLE_MS;
        moved = 0;
        if (wasScroll) {
          e.preventDefault();
          e.stopPropagation();
        }
      },
      true
    );

    row.addEventListener(
      'scroll',
      () => {
        lastScrollAt = performance.now();
        update(row, prev, next, wrap);
      },
      { passive: true }
    );
    window.addEventListener('resize', () => update(row, prev, next, wrap));

    update(row, prev, next, wrap);
    requestAnimationFrame(() => update(row, prev, next, wrap));
  }

  function wireAll() {
    document.querySelectorAll('[data-upsell-carousel]').forEach(wire);
  }

  ['theme:cart:added', 'theme:cart:update', 'theme:cart:refresh'].forEach((ev) => {
    document.addEventListener(ev, () => setTimeout(wireAll, 0));
  });

  const drawer = document.getElementById('cart-drawer');
  if (drawer && window.MutationObserver) {
    new MutationObserver(() => wireAll()).observe(drawer, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', wireAll);
  } else {
    wireAll();
  }
})();
